module.exports = __webpack_public_path__ + "assets/img/LTC004.e2ed5bf1.png";